import React from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ActionButton = ({ icon: Icon, title, description, onClick }) => (
  <Button
    variant="outlined"
    fullWidth
    onClick={onClick}
    sx={{
      p: 3,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      textAlign: 'left',
      textTransform: 'none'
    }}
  >
    <Icon sx={{ fontSize: 40, mb: 2, color: 'primary.main' }} />
    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {description}
    </Typography>
  </Button>
);

const NowWhatSection = ({
  sectionIcon,
  actions = []
}) => {
  const navigate = useNavigate();

  // Dynamically calculate grid size based on number of actions
  // 1 action = 12 (full width), 2 actions = 6 (half each), 3+ actions = 4 (third each)
  const gridSize = Math.max(4, 12 / Math.min(actions.length, 3));

  return (
      <Grid container spacing={3}>
        {actions.map((action, index) => (
          <Grid item xs={12} md={gridSize} key={index}>
            <ActionButton
              icon={action.icon}
              title={action.title}
              description={action.description}
              onClick={() => navigate(action.path)}
            />
          </Grid>
        ))}
      </Grid>
  );
};

export default NowWhatSection;